import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const PostCard = ({ post, onReact, onFlag, onEdit, onDelete, userReaction }) => {
  const [activeReaction, setActiveReaction] = useState(null);
  const [showEditOptions, setShowEditOptions] = useState(false);

  const handleReaction = (reactionType) => {
    // If clicking the same reaction user already has, do nothing
    if (userReaction === reactionType) {
      return;
    }

    setActiveReaction(reactionType);
    onReact(post?.id, reactionType);
    
    setTimeout(() => {
      setActiveReaction(null);
    }, 300);
  };

  const handleFlag = () => {
    onFlag(post?.id);
  };

  const reactions = [
    {
      type: 'relate',
      label: 'I feel you',
      icon: 'Heart',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      hoverBg: 'hover:bg-accent/20'
    },
    {
      type: 'correct',
      label: 'You\'re not alone',
      icon: 'Users',
      color: 'text-success',
      bgColor: 'bg-success/10',
      hoverBg: 'hover:bg-success/20'
    },
    {
      type: 'notBest',
      label: 'Sending strength',
      icon: 'Sparkles',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      hoverBg: 'hover:bg-warning/20'
    }
  ];

  return (
    <article className="bg-card rounded-xl lg:rounded-2xl p-5 md:p-6 lg:p-8 shadow-sm hover-glow transition-therapeutic">
      <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-5">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-primary/10 rounded-full flex-shrink-0">
          <Icon 
            name="User" 
            size={20} 
            color="var(--color-primary)" 
            strokeWidth={2}
            className="md:w-6 md:h-6 lg:w-7 lg:h-7"
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className="caption text-muted-foreground">
            Anonymous • {post?.timeAgo}
          </p>
        </div>
      </div>
      <div className="mb-5 md:mb-6 lg:mb-8">
        <p className="text-sm md:text-base lg:text-lg text-foreground leading-relaxed whitespace-pre-line">
          {post?.content}
        </p>
      </div>
      <div className="flex flex-col gap-3 md:gap-4">
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
          {reactions?.map((reaction) => {
            const count = post?.reactions?.[reaction?.type] || 0;
            const isActive = activeReaction === reaction?.type;
            const isUserReaction = userReaction === reaction?.type;
            
            return (
              <button
                key={reaction?.type}
                onClick={() => handleReaction(reaction?.type)}
                className={`
                  flex items-center justify-center gap-2 md:gap-3 px-4 md:px-5 lg:px-6 py-3 md:py-3.5 lg:py-4
                  ${reaction?.bgColor} ${reaction?.hoverBg}
                  rounded-lg lg:rounded-xl transition-therapeutic press-scale focus-ring
                  ${isActive ? 'scale-95' : ''}
                  ${isUserReaction ? 'ring-2 ring-offset-2 ring-offset-card' : ''}
                  ${isUserReaction ? `ring-${reaction?.type === 'relate' ? 'accent' : reaction?.type === 'correct' ? 'success' : 'warning'}` : ''}
                  min-h-[44px] flex-1 sm:flex-initial
                `}
                aria-label={`${reaction?.label} - ${count} reactions${isUserReaction ? ' (your reaction)' : ''}`}
              >
                <Icon 
                  name={reaction?.icon}
                  size={18}
                  color={`var(--color-${reaction?.type === 'relate' ? 'accent' : reaction?.type === 'correct' ? 'success' : 'warning'})`}
                  strokeWidth={isUserReaction ? 2.5 : 2}
                  className="md:w-5 md:h-5 lg:w-6 lg:h-6 flex-shrink-0"
                />
                <span className={`text-xs md:text-sm lg:text-base font-medium ${reaction?.color} line-clamp-1 ${isUserReaction ? 'font-semibold' : ''}`}>
                  {reaction?.label}
                </span>
                <span className={`caption ${reaction?.color} font-semibold ml-auto whitespace-nowrap`}>
                  {count}
                </span>
              </button>
            );
          })}
        </div>
        <button
          onClick={handleFlag}
          className="flex items-center justify-center gap-2 px-4 py-2.5 bg-muted hover:bg-muted/80 rounded-lg transition-therapeutic press-scale focus-ring"
          title="Use this if the post includes identifying information"
        >
          <Icon name="Flag" size={16} strokeWidth={2} />
          <span className="text-xs md:text-sm text-muted-foreground">
            Not anonymous
          </span>
        </button>
      </div>
    </article>
  );
};

export default PostCard;